export default class slider {
    constructor(manager,scene) {

        //manager
        this.manager = manager;
        this.sceneManager = scene;

    }
    init(){

        //prev
        this.sceneManager.$prev.addEventListener("click",()=>{
            if(this.sceneManager.status.mode == 'scroll' || this.sceneManager.status.motion) return;
            this.out();
            if(this.sceneManager.status.current == 0){
                this.sceneManager.status.next = this.sceneManager.status.max;
            }else{
                this.sceneManager.status.next = Number(this.sceneManager.status.current) - 1;
            }
            this.in();
        });
        //next
        this.sceneManager.$next.addEventListener("click",()=>{
            if(this.sceneManager.status.mode == 'scroll' || this.sceneManager.status.motion) return;
            this.out();
            if(this.sceneManager.status.current == this.sceneManager.status.max){
                this.sceneManager.status.next = 0;
            }else{
                this.sceneManager.status.next = Number(this.sceneManager.status.current) + 1;
            }
            this.in();
        });

    }
    out(){
        TweenMax.to(this.sceneManager.$slideList[this.sceneManager.status.current],2.0,{
            display:'none',
            opacity:0,
            scale:1.08,
            rotation:1,
            ease: Power2.easeOut,
        });
        this.sceneManager.status.current = this.sceneManager.status.next;
    }
    in(){

        this.manager.color.set(
            this.sceneManager.colorArray.logoColor[this.sceneManager.status.next],
            this.sceneManager.colorArray.snsColor[this.sceneManager.status.next],
            this.sceneManager.colorArray.footerColor[this.sceneManager.status.next],
            this.sceneManager.colorArray.menuColor[this.sceneManager.status.next],
            this.sceneManager.colorArray.headerOpacity[this.sceneManager.status.next]
        );

        TweenMax.fromTo(this.sceneManager.$slideList[this.sceneManager.status.next],2.6,{
            display:'none',
            opacity:0,
            scale:1.08,
            rotation:-1,
        },{
            display:'block',
            opacity:1,
            scale:1,
            rotation:0,
            ease: Power2.easeOut,
        });
        this.sceneManager.status.current = this.sceneManager.status.next;
    }
    resize(){

    }
}